import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import Auth from '../../Layout/Auth';

import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Lazy load components for better performance
const OrganisationList = lazy(() => import('../Organization/Organization'));
const SupportUserList = lazy(() => import('../SupportUser/SupportUser'));
const AdminUserList = lazy(() => import('../Users/Pages/User/Users'));

/**
 * Store module routes
 * @param {Object} props - Component props
 * @returns {JSX.Element} - Store routes
 */
const HomeRoute = (props) => {
    const { history } = props;

    return (
        <>
            <Route
                exact
                path="/:lng/home/organisation"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin']}>
                        <Suspense fallback={<Loading />}>
                            <OrganisationList history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/home/support_user"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin']}>
                        <Suspense fallback={<Loading />}>
                            <SupportUserList history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/home/admin"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin']}>
                        <Suspense fallback={<Loading />}>
                            <AdminUserList history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
        </>
    );
};
function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading</span>
            </div>
        </>
    );
}
export default HomeRoute;
